<template>
  <div class="badge" :style="{ 'background-color': serverStatus.bgColor }">
    <div class="circle"></div>
    {{ serverStatus.type }} Server
  </div>
</template>

<script>
export default {
  computed: {
    serverStatus() {
      if (process.env.NODE_ENV == "local") {
        return {
          type: "Local",
          bgColor: "#ff7233"
        };
      }
      switch (window.location.origin) {
        case "http://localhost:8080":
          return {
            type: "Local",
            bgColor: "#ff7233"
          };
        case "http://localhost:3000":
          return {
            type: "Local",
            bgColor: "#ff7233"
          };
        case "http://0.0.0.0:3000":
          return {
            type: "Local",
            bgColor: "#ff7233"
          };
        case "http://0.0.0.0:8080":
          return {
            type: "Local",
            bgColor: "#ff7233"
          };
        case "http://dev.winepoint.co.kr":
          return {
            type: "Dev",
            bgColor: "#d711ff"
          };
        case "http://dev.winepoint.co.kr:3000":
          return {
            type: "Dev",
            bgColor: "#d711ff"
          };
        case "http://admin.winepoint.co.kr":
          return {
            type: "Live",
            bgColor: "#05b7ff"
          };
        case "https://admin.winepoint.co.kr":
          return {
            type: "Live",
            bgColor: "#05b7ff"
          };
        case "http://admin2.winepoint.co.kr":
          return {
            type: "Live",
            bgColor: "#05b7ff"
          };
        case "https://admin2.winepoint.co.kr:3000":
          return {
            type: "Live",
            bgColor: "#05b7ff"
          };
        default:
          return {
            type: "undefined",
            bgColor: "#000000"
          };
      }
    }
  }
};
</script>

<style lang="scss">
@keyframes live {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.badge {
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 500;
  top: 14px;
  right: 16px;
  background-color: #ff4e62;
  border-radius: 24px;
  padding: 6px 14px;
  transition: all 0.3s;

  font-size: 14px;
  color: #ffffff;
  font-weight: 600;

  animation: live 3s infinite;

  .circle {
    width: 10px;
    height: 10px;
    border-radius: 24px;
    margin-right: 6px;
    background-color: #9cff21;
  }

  &:hover {
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/ServerStatusBadge.vue